module.exports = __webpack_public_path__ + "static/media/ipad-pro-chart-landscape-reduced.c7e41e1a.png";